/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";

//共通コンポーネント
import { Header, MainColorButton, Loading } from "../../components";
import { bottomButton } from "../../common/styles";
import masterCardImg from "./img/masterCard.png";
import visaCardImg from "./img/visaCard.png";
import americanExpressImg from "./img/americanExpress.jpeg";
import jcbImg from "./img/jcb.gif";
import dinersClubImg from "./img/dinersClub.gif";
import { PAYING_PAGE } from "../../routes/path";
import { getPastPaymentCard, setOperationLogOutput } from "../../server/axios";
import { ERROR } from "../../routes/path";
import { closeKeyboard } from "../../utils/closeKeyboard";

/**
 * クレジットカード選択
 * @returns
 */
const SelectCreditCardPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  const [expireYear, setExpireYear] = useState("");
  const [expireMonth, setExpireMonth] = useState("");
  const [cardNo, setCardNo] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [isGmoMember, setIsGmoMember] = useState(false);
  const [gmoToken, setGmoToken] = useState("");
  const [gmoShopId, setGmoShopId] = useState("");
  //エラーメッセージ表示
  const [openSnackbar, setOpenSnackbar] = useState({
    status: false,
    message: "",
  });
  const handleSnackbarClose = () => {
    setOpenSnackbar({
      status: false,
      message: "",
    });
  };

  const [historyCards, setHistoryCards] = useState([]);
  const [custmerId, setCustmerId] = useState("");
  const [selectedOption, setSelectedOption] = useState("newCard");
  const [selectedCardSeq, setSelectedCardSeq] = useState("0");

  useEffect(() => {
    setLoadingOpen(true);
    let custmerId = "";
    let receiptedNumber = "";
    if (
      !location.state?.customerId ||
      !location.state?.receiptedNumber ||
      !location.state?.updateDatetime ||
      !location.state?.gmoShopId
    ) {
      navigate(ERROR);
    } else {
      custmerId = location.state.customerId;
      receiptedNumber = location.state.receiptedNumber;
      setCustmerId(custmerId);
      getPastPaymentCardList(custmerId, receiptedNumber);

      const head = document.getElementsByTagName("head")[0];
      const scriptUrl = document.createElement("script");
      if (location.state.gmoShopId.startsWith("tshop")) {
        scriptUrl.src = "https://stg.static.mul-pay.jp/ext/js/token.js";
      } else {
        scriptUrl.src = "https://static.mul-pay.jp/ext/js/token.js";
      }
      head.appendChild(scriptUrl);
    }
  }, []);

  const getPastPaymentCardList = (customerId, receiptedNumber) => {
    getPastPaymentCard({
      custmerId: customerId,
      receiptedNumber: receiptedNumber,
    }).then((res) => {
      setGmoShopId(res.data.gmoShopId);
      setIsGmoMember(res.data.isGmoMember);
      if (res.data.result === -2) {
        setHistoryCards([]);
      } else if (res.data.result === -3) {
        setHistoryCards([]);
      } else if (res.data.result === -5) {
        setHistoryCards([]);
      } else {
        if (res.data.target.length === 0) {
          setHistoryCards([]);
        } else {
          setHistoryCards(res.data.target);
          setSelectedOption("existingCard");
        }
      }
      setLoadingOpen(false);
    });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleRadioChange = (event) => {
    setSelectedCardSeq(event.target.value);
  };

  const postLog = async (message) => {
    await setOperationLogOutput({
      from: "react",
      type: "Line",
      ...message,
    });
  };

  const setMedicalAccounting = () => {
    if (selectedOption === "newCard") {
      let messageList = [];
      if (!cardNo) {
        messageList.push("カード番号を入力してください。");
      } else if (cardNo.length < 14) {
        messageList.push("カード番号は正しくありません。");
      }
      if (!expireMonth || !expireYear) {
        messageList.push("有效期限を入力してください。");
      } else if (!/\d{2}(0[1-9]|1[0-2])/.test(`${expireYear}${expireMonth}`)) {
        messageList.push("有効期限は正しくありません。");
      }
      if (!securityCode) {
        messageList.push("セキュリティコードを入力してください。");
      } else if (securityCode.length < 3 || securityCode.length > 4) {
        messageList.push("セキュリティコードは正しくありません。");
      }

      if (messageList.length > 0) {
        setOpenSnackbar({
          status: true,
          message: (
            <>
              {messageList.map((info, index) => (
                <div key={index} style={{ display: "inline" }}>
                  <br />
                  <strong>{info}</strong>
                </div>
              ))}
            </>
          ),
        });
        return;
      }
      // GMO token決済
      // eslint-disable-next-line no-undef
      Multipayment.init(gmoShopId);
      // eslint-disable-next-line no-undef
      Multipayment.getToken(
        {
          cardno: cardNo,
          expire: `${expireYear}${expireMonth}`,
          securitycode: securityCode,
        },
        async (execPurchase) => {
          if (execPurchase.resultCode === "000") {
            setGmoToken(execPurchase.tokenObject.token);
            navigate(PAYING_PAGE, {
              state: {
                custmerId: custmerId,
                useHistryCard: false,
                receiptedNumber: location.state.receiptedNumber,
                paymentMethodClass: location.state.paymentMethodClass,
                destination: "確認",
                gmoToken: execPurchase.tokenObject.token,
                isGmoMember: isGmoMember,
                updateDatetime: location.state.updateDatetime,
              },
            });
          } else {
            const message = `決済処理に失敗しました。再度決済を行ってください。`;
            setOpenSnackbar({
              status: true,
              message: (
                <>
                  <div style={{ display: "inline" }}>
                    <br />
                    <strong>{message}</strong>
                  </div>
                </>
              ),
            });
            return await postLog({
              gmoShopId: gmoShopId,
              execPurchase: execPurchase.resultCode,
            });
          }
        }
      );
    } else {
      if (historyCards.length === 0) {
        setOpenSnackbar({
          status: true,
          message: (
            <>
              <div style={{ display: "inline" }}>
                <br />
                <strong>
                  過去ご利用のカードがありません。カードを登録してください。
                </strong>
              </div>
            </>
          ),
        });
        return;
      }
      navigate(PAYING_PAGE, {
        state: {
          custmerId: custmerId,
          useHistryCard: true,
          receiptedNumber: location.state.receiptedNumber,
          paymentMethodClass: location.state.paymentMethodClass,
          selectedCardSeq: selectedCardSeq,
          gmoToken: gmoToken,
          isGmoMember: isGmoMember,
          updateDatetime: location.state.updateDatetime,
        },
      });
    }
  };

  const cardTypeList = [
    {
      name: "visa",
      img: visaCardImg,
    },
    {
      name: "master",
      img: masterCardImg,
    },
    {
      name: "americanExpress",
      img: americanExpressImg,
    },
    {
      name: "jcb",
      img: jcbImg,
    },
    {
      name: "dinersClub",
      img: dinersClubImg,
    },
  ];

  const imageStyle = {
    width: "80%",
  };

  const imageBoxStyle = {
    width: "25%",
    height: "5.5vh",
    borderRadius: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title="クレジットカード決済" />
      <Snackbar
        open={openSnackbar.status}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleSnackbarClose}
        sx={{ mt: "8vh" }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={handleSnackbarClose}
        >
          {openSnackbar.message}
        </Alert>
      </Snackbar>
      <Stack
        height="76vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
        spacing="8%"
        sx={{ height: "76vh", overflowY: "scroll" }}
      >
        <Box sx={{ width: "100%" }}>
          <RadioGroup value={selectedOption} onChange={handleOptionChange}>
            <FormControlLabel
              value="existingCard"
              control={<Radio />}
              checked={selectedOption === "existingCard"}
              label={"過去ご利用のカードを使用"}
              disabled={historyCards.length < 1}
            />
            {selectedOption === "existingCard" && (
              <Box
                sx={{ marginLeft: "8%", marginTop: "1vh", marginBottom: "3vh" }}
              >
                <RadioGroup
                  value={selectedCardSeq}
                  onChange={handleRadioChange}
                >
                  {historyCards.map((card) => (
                    <FormControlLabel
                      key={card.CardSeq}
                      value={card.CardSeq}
                      control={<Radio />}
                      label={card.CardNo}
                      checked={card.CardSeq === selectedCardSeq}
                    />
                  ))}
                </RadioGroup>
              </Box>
            )}

            <FormControlLabel
              value="newCard"
              control={<Radio />}
              label={"新しいカードを登録"}
              checked={selectedOption === "newCard"}
            />
            <Stack
              width="85%"
              marginLeft="8%"
              direction="row"
              alignItems="center"
              spacing={2}
            >
              {cardTypeList.map((item, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      ...imageBoxStyle,
                    }}
                  >
                    <img
                      src={item.img}
                      style={{ ...imageStyle }}
                      alt={item.cardType}
                      onClick={() => {
                        setCardType(item.name);
                      }}
                    />
                  </Box>
                );
              })}
            </Stack>
            <Box sx={{ marginLeft: "8%", marginTop: "3vh" }}>
              <Typography>カード番号</Typography>
              <Box sx={{ marginLeft: "16%", marginTop: "1vh" }}>
                <TextField
                  disabled={selectedOption === "existingCard"}
                  hiddenLabel
                  fullWidth
                  size="small"
                  value={cardNo}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^\d]/g, "");
                    if (v.length > 16) {
                      v = v.substring(0, 16);
                    }
                    setCardNo(v);
                  }}
                  onKeyDown={(event) => closeKeyboard(event)}
                ></TextField>
              </Box>

              <Box sx={{ marginTop: "3vh" }}>
                <Typography>有効期限</Typography>
                <Box sx={{ marginLeft: "16%", marginTop: "1vh" }}>
                  <Stack
                    width="85%"
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <TextField
                      disabled={selectedOption === "existingCard"}
                      width="30%"
                      hiddenLabel
                      size="small"
                      type="number"
                      value={expireMonth}
                      onChange={(e) => {
                        let v = e.target.value;
                        if (v.length > 2) {
                          v = v.substring(0, 2);
                        }
                        if (Number(v) > 12) {
                          v = 12;
                        }
                        setExpireMonth(v);
                      }}
                      onKeyDown={(event) => closeKeyboard(event)}
                    ></TextField>
                    <Typography align="center" width="30%">
                      /
                    </Typography>
                    <TextField
                      disabled={selectedOption === "existingCard"}
                      width="30%"
                      hiddenLabel
                      size="small"
                      type="number"
                      value={expireYear}
                      onChange={(e) => {
                        let v = e.target.value;
                        if (v.length > 2) {
                          v = v.substring(0, 2);
                        }
                        setExpireYear(v);
                      }}
                      onKeyDown={(event) => closeKeyboard(event)}
                    ></TextField>
                  </Stack>
                  <Stack
                    width="85%"
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography align="center" width="30%">
                      {"（MM）"}
                    </Typography>
                    <Typography align="center" width="30%"></Typography>
                    <Typography align="center" width="30%">
                      {"（YY）"}
                    </Typography>
                  </Stack>
                </Box>
              </Box>

              <Box sx={{ marginTop: "3vh" }}>
                <Typography>セキュリティコード</Typography>
                <Box sx={{ marginLeft: "16%", marginTop: "1vh" }}>
                  <TextField
                    disabled={selectedOption === "existingCard"}
                    fullWidth
                    hiddenLabel
                    size="small"
                    value={securityCode}
                    onChange={(e) => setSecurityCode(e.target.value)}
                    onKeyDown={(event) => closeKeyboard(event)}
                    inputProps={{ maxLength: 4 }}
                  ></TextField>
                </Box>
              </Box>
              <Box sx={{ height: "250px" }} />
            </Box>
          </RadioGroup>
        </Box>
      </Stack>

      <MainColorButton
        label="決済"
        style={bottomButton}
        onClick={() => setMedicalAccounting()}
      />
    </>
  );
};

export default SelectCreditCardPage;
